import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
  table: {
    maxHeight: 500,
    marginBottom: '20px',
    borderRadius: 0
  },
  heading: {
    color: '#335977',
    fontSize: '20px',
    marginBottom: '10px',
    marginTop: '10px'
  },
  spacing: {
  },
  tableHeader: {
    border: 'none',
    backgroundColor: '#EBEBEB',
    fontSize: '14px',
    letterSpacing: '0.07px',
    fontFamily: 'Roboto, sans-serif',
    whiteSpace: 'nowrap'
  },
  headerWrapper: {
    color: '#2E2E2E',
    fontWeight: 600,
    fontSize: '14px',
    padding: 0
  },
  paginationWrapper: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: '#4A4A4A',
    fontSize: '14px',
    flexWrap: 'wrap'
  },
  paginationSelectWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  selectRoot: {
    minWidth: '50px',
  },
  selectWrapper: {
    margin: '0 10px 0 20px'
  },
  sortIcon: {
    color: '#FFFFFF',
    marginLeft: '2px'
  },
  noPointer: {
    pointerEvents: 'none'
  },
  tableHeading: {
    '& span': {
      fontSize: '14px'
    },
  },
  dropDownValues: {
    cursor: 'pointer',
    padding: '8px 12px',
    fontSize: '12px'
  },
  popoverPaper: {
    width: '220px',
  },
  active: {
    backgroundColor: '#D6D1CE',
    margin: '3px',
    borderRadius: '8px',
    color: '#000000',
    fontWeight: 'bold'
  },
  infoIcon: {
    fontSize: '14px',
    cursor: 'pointer'
  },
  infoPopover: {
    color: '#4A4A4A',
    fontSize: '14px',
    opacity: '70%',
    textAlign: 'left',
  },
  infoPopoverPaper: {
    width: '250px'
  }
})

export { useStyles }